export default {"src":"/_next/static/media/partner33.519945f8.svg","height":42,"width":250,"blurWidth":0,"blurHeight":0};